export const REACT_APP_BUILD_TIME="2025-01-10T21:02:31.007Z"